import { IHallBooking } from "src/domain/entities"
import { hallBookingUpdateApi } from "../../api/hallBooking/hallBookingUpdateApi"

type PayloadShape = Parameters<typeof hallBookingUpdateApi>[0]

export async function hallBookingUpdateService(
	payload: PayloadShape,
	token?: null | string,
) {
	const hallBooking = await hallBookingUpdateApi(payload, token)
	return hallBooking as NonNullable<IHallBooking>
}
